module.exports = __webpack_public_path__ + "img/img_complete.5545f2c6.png";